module.exports = __webpack_public_path__ + "img/purchase-icon.50022e1d.svg";